module.exports = __webpack_public_path__ + "img/Willem.515261ae.png";